import { Container, Typography } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout"

const Privacy = () => {
  return (
    <Layout>
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography paragraph>
        At F-AI, we value your privacy. This policy outlines how we collect,
        use, and safeguard your personal information.
      </Typography>
      <Typography paragraph>
        - We collect basic details (name, email, phone) only for service
        purposes. <br />
        - We never sell or share your data with third parties. <br />
        - All payments are processed securely via Razorpay.
      </Typography>
    </Container>
    </Layout>
  );
};

export default Privacy;
